import { z } from 'zod';
import { ReportIssueParamsSchema } from './report-issue';

export enum LLMUsageCheckResultStatus {
  GOOD = 'good',
  NEEDS_IMPROVEMENT = 'needs_improvement',
  IRRELEVANT = 'irrelevant',
}

export const CheckResultSchema = z.object({
  id: z.string(),
  status: z.enum(
    Object.values(LLMUsageCheckResultStatus) as [
      LLMUsageCheckResultStatus,
      ...LLMUsageCheckResultStatus[],
    ],
  ),
  correctedAnswer: z.string(),
  correctedURL: z.string(),
  reportIssue: z.boolean(),
  reportIssueParams: ReportIssueParamsSchema.optional(),
  useForAIKnowledgeData: z.boolean(),
  // When true, the training document resulting from this question is routed to the
  // Priority Knowledge folder (separate file) instead of the regular Train A.I. file.
  isPriorityKnowledge: z.boolean().optional(),
  checkedBy: z.string().optional(),
  checkedByName: z.string().optional(), // set on backend side by checkedBy field
  checkedAt: z.string().optional(),
  isReoptimization: z.boolean().optional(),
  requestedLLMBlockId: z.string().optional(),
  requestedHotTopicId: z.string().optional(),
  // ID of the sibling document whose checkResult the core cleared during
  // reoptimization (present only when a document's checkResult was removed
  // because it had no remaining primary evaluations in other contexts).
  clearedCheckResultDocId: z.string().optional(),
});

export type TCheckResult = z.infer<typeof CheckResultSchema>;

export const STATUSES = {
  [LLMUsageCheckResultStatus.GOOD]: {
    icon: 'check-mark-button.svg',
    fontColorHex: '#5cd890',
    bgColorRGBA: 'rgba(111, 207, 151, .15)',
  },
  [LLMUsageCheckResultStatus.NEEDS_IMPROVEMENT]: {
    icon: 'hammer-and-wrench.svg',
    fontColorHex: '#0554e3',
    bgColorRGBA: 'rgba(47, 128, 237, .15)',
  },
  [LLMUsageCheckResultStatus.IRRELEVANT]: {
    icon: 'poo.svg',
    fontColorHex: '#997561',
    bgColorRGBA: 'rgba(115, 66, 38, .15)',
  },
};

export const URL_REMOVAL_FLAG = '[REMOVED]';
